import React, { useRef } from 'react'
import styled from 'styled-components'
import { styleTheme } from '../../../../style/theme'
import { getPrimaryColor } from '../../../../style/utils'
import '@splidejs/react-splide/dist/css/splide.min.css'

import { SliderProps, SliderContainerProps } from './Slider.types'
import { Splide, SplideSlide, Options } from '@splidejs/react-splide'

import { RecommendedBridalFairs } from '../PickupParticularFairs'

const ARROW_PATH =
  'M13.6875 7.71875L8.6875 12.7188C8.5 12.9062 8.25 13 8 13C7.71875 13 7.46875 12.9062 7.28125 12.7188C6.875 12.3438 6.875 11.6875 7.28125 11.3125L10.5625 8H1C0.4375 8 0 7.5625 0 7C0 6.46875 0.4375 6 1 6H10.5625L7.28125 2.71875C6.875 2.34375 6.875 1.6875 7.28125 1.3125C7.65625 0.90625 8.3125 0.90625 8.6875 1.3125L13.6875 6.3125C14.0938 6.6875 14.0938 7.34375 13.6875 7.71875Z'

const MAIN_SLIDER_OPTIONS: Options = {
  type: 'slide',
  perPage: 5,
  perMove: 1,
  arrows: true,
  gap: 4,
  arrowPath: ARROW_PATH,
  cover: true,
  trimSpace: 'move',
  focus: 'center',
  omitEnd: true,
  fixedWidth: '31.5%',

  breakpoints: {
    680: {
      perPage: 3,
      fixedWidth: '40%',
    },
    480: {
      perPage: 1,
      fixedWidth: '67.5%',
    },
  },
} as const

export const Slider: React.FC<SliderContainerProps> = ({ pickupParticularFairs, ...restProps }) => {
  const mainSliderRef = useRef(null)

  return <StyledPage {...restProps} mainSliderRef={mainSliderRef} pickupParticularFairs={pickupParticularFairs} />
}

const Page: React.FC<SliderProps> = ({
  className,
  mainSliderRef,
  pickupParticularFairs,
  primaryColor,
  bridalFairPageKey,
  holidays,
}) => {
  return (
    <div className={className}>
      <Splide className="main" ref={mainSliderRef} options={MAIN_SLIDER_OPTIONS}>
        {pickupParticularFairs?.map((pickupParticularFair) => (
          <SplideSlide key={pickupParticularFair.id}>
            <div className="slide-item">
              <RecommendedBridalFairs
                pickupParticularFair={pickupParticularFair}
                column={true}
                primaryColor={primaryColor}
                bridalFairPageKey={bridalFairPageKey}
                holidays={holidays}
              />
            </div>
          </SplideSlide>
        ))}
      </Splide>
    </div>
  )
}

const StyledPage = styled(Page)`
  padding: 0 20px;
  @media screen and (max-width: 480px) {
    padding: 0;
  }

  .splide__pagination {
    bottom: -20px;
  }

  .splide__pagination__page {
    width: 8px;
    height: 8px;
    background-color: ${styleTheme.colors.gray.light};
    border-radius: 50%;
    margin: 0 4px;
  }

  .splide__pagination__page.is-active {
    background-color: ${styleTheme.colors.black};
  }

  .splide__arrow {
    background-color: ${getPrimaryColor};
    width: 48px;
    height: 48px;
    border-radius: 25px;

    > svg {
      fill: rgb(255, 255, 255);
      > path {
        scale: 2.5;
      }
    }
  }

  .splide__arrow--prev {
    left: 0;
  }

  .splide__arrow--next {
    right: 0;
  }
`
